import { UnicodeEmoji } from "~/client/features/emoji/UnicodeEmoji";

export class UnicodeEmojiElement extends HTMLSpanElement {
  unicodeEmoji: UnicodeEmoji | null;

  constructor() {
    super();

    this.unicodeEmoji = null;
  }

  connectedCallback() {
    this.unicodeEmoji = new UnicodeEmoji(this.title!);
    this.addClassName();
  }

  addClassName() {
    if (this.unicodeEmoji) {
      this.classList.add(...this.unicodeEmoji.getClassNames());
    }
  }
}
